import shortlink from './images/shortlink.svg';
import qr from './images/qr.svg';
import tutu2 from './images/tutu2.png';
import tutu from './images/tutu.png';
import check from './images/check.png';
import yinxun from './images/yinxun.jpg';
import renlian from './images/renlian.png';
import paihang from './images/paihang.png';
import aivideo from './images/aivideo.png';
import ocr from './images/ocr.png';
import aipaint from './images/aipaint.png';
import poster from './images/poster.png';
import clouddisk from './images/clouddisk.svg';
import xinhua from './images/xinhua.svg';
import copyright from './images/copyright.png';

import videoToGIF from './images/software/11.png';
import p12 from './images/software/12.png';
import p13 from './images/software/13.png';
import p15 from './images/software/15.png';
import p16 from './images/software/16.png';
import p17 from './images/software/17.png';
import p18 from './images/software/18.png';
import p19 from './images/software/19.png';
import p20 from './images/software/20.png';
import p21 from './images/software/21.png';
import p22 from './images/software/22.png';
import p23 from './images/software/23.png';
import p24 from './images/software/24.png';
import p25 from './images/software/25.png';
import p26 from './images/software/26.png';
import p27 from './images/software/27.png';
import p28 from './images/software/28.png';
import p29 from './images/software/29.png';
import p30 from './images/software/30.png';
import p31 from './images/software/31.png';
import p32 from './images/software/32.png';
import p33 from './images/software/33.png';
import p34 from './images/software/34.png';
import p35 from './images/software/35.png';
import p36 from './images/software/36.png';
import p37 from './images/software/37.png';
import p38 from './images/software/38.png';
import p39 from './images/software/39.png';
import p40 from './images/software/40.png';
import p41 from './images/software/41.png';
import p42 from './images/software/42.png';
import p43 from './images/software/43.png';
import p44 from './images/software/44.png';
import p45 from './images/software/45.png';
import p46 from './images/software/46.png';
import p47 from './images/software/47.png';
import p48 from './images/software/48.png';
import p49 from './images/software/49.png';

import gold from './images/software/gold.png';


const tools = {

  products: [
    {
      type: "website",
      icon_url: videoToGIF,
      title: "GIF动图",
      subtitle: "GIF动图",
      website_url: "/toolbox/gif",
      target: '_blank'
    },
    {
      type: "website",
      icon_url: qr,
      title: "图图·二维码",
      subtitle: "在线链接转二维码生成服务",
      website_url: "http://ai.home.xinhua-news.com/portal/qrcode/",
      // website_url: "/toolbox/qrcode",
      // isNew: true,
      target: '_blank',
    },
    {
      type: "website",
      icon_url: shortlink,
      title: "短链接生成器",
      subtitle: "转换为简短的网址字符串",
      website_url: "/toolbox/shortlink",
      target: '_self'
    },
    // {
    //   type: "website",
    //   icon_url: tutu,
    //   title: "图图",
    //   subtitle: "一款在线生成可视化数据视频及信息图表的工具",
    //   website_url: "http://ai.home.xinhua-news.com/ai/datanews/",
    //   // website_url: "http://ai.home.xhtxs.com/ai/datanews/",
    //   target: '_blank',
    //   isNew: true,
    //   helpUrl: 'https://v.xinhua-news.com/nspfeatures/recommend/tutu.mp4'
    // },
    {
      type: "website",
      icon_url: check,
      title: "新华较真",
      subtitle: "使用深度学习的大规模样本训练，自动识别文本错误和不一致性表达，为您提供可靠的内容保障",
      website_url: "http://ai.home.xinhua-news.com/portal/aicheck_ui1/",
      // website_url: "http://ai.home.xhtxs.com/portal/aicheck_ui/",
      target: '_blank',
      // isNew: true,
      helpUrl: 'https://v.xinhua-news.com/nspfeatures/recommend/aiCheck.mp4'
    },
    {
      type: "website",
      icon_url: tutu2,
      title: "图图·可视化",
      subtitle: "在线数据视频及图表生成工具",
      website_url: "http://ai.home.xinhua-news.com/datanews/tutu/",
      // website_url: "http://ai.home.xhtxs.com/datanews/tutu/",
      target: '_blank',
      // isNew: true,
      helpUrl: 'https://v.xinhua-news.com/nspfeatures/recommend/tutu2.mp4'
    },
    {
      type: "website",
      icon_url: yinxun,
      title: "智能音讯工具",
      subtitle: "录音转写",
      website_url: "http://ai.home.xinhua-news.com/AudioToText/",
      // website_url: "http://ai.home.xhtxs.com/AudioToText/",
      target: '_blank',
      // isNew: true,
      helpUrl: 'https://v.xinhua-news.com/nspfeatures/recommend/yinxun.mp4'
    },
    {
      type: "website",
      icon_url: renlian,
      title: "AI识图",
      subtitle: "即刻体验人脸检测能力",
      website_url: "http://ai.home.xinhua-news.com/face_rec/synsys/index.html",
      // website_url: "http://ai.home.xhtxs.com/face_rec/synsys/index.html",
      target: '_blank',
      // isNew: true,
      helpUrl: 'https://v.xinhua-news.com/nspfeatures/recommend/aiimagehelp.mp4'
    },
    {
      type: "website",
      icon_url: paihang,
      title: "热点稿件排行",
      subtitle: "热点稿件排行",
      website_url: "http://home.xinhua-news.com/toolbox/rank/",
      // website_url: "http://home.xhtxs.com/toolbox/rank/",
      target: '_blank',
      // isNew: true,
      // helpUrl: 'https://v.xinhua-news.com/nspfeatures/recommend/aiimagehelp.mp4'
    },
    {
      type: "aivideo",
      icon_url: aivideo,
      title: "AI Video",
      subtitle: "AI Video",
      website_url: "https://aivideo.xinhua-news.com",
      // website_url: "http://home.xhtxs.com/toolbox/rank/",
      target: '_blank',
      // isNew: true,
      // helpUrl: 'https://v.xinhua-news.com/nspfeatures/recommend/aiimagehelp.mp4'
    },
    {
      type: "website",
      icon_url: ocr,
      title: "OCR识别",
      subtitle: "多场景、任意版面下整图文字的识别",
      website_url: "http://ai.home.xinhua-news.com/portal/ocrSyn/",
      // website_url: "http://ai.home.xhtxs.com/portal/aicheck_ui/",
      target: '_blank',
      // isNew: true,
      helpUrl: 'https://v.xinhua-news.com/nspfeatures/recommend/ocrhelp.mp4'
    },
    {
      type: "website",
      icon_url: aipaint,
      title: "灵犀AI作画",
      subtitle: "“新”有灵犀，人人都是艺术家！",
      website_url: "http://ai.home.xinhua-news.com/lingxi/",
      // website_url: "http://ai.home.xhtxs.com/portal/aicheck_ui/",
      target: '_blank',
      // isNew: true,
      // helpUrl: 'https://v.xinhua-news.com/nspfeatures/recommend/ocrhelp.mp4'
    },
    {
      type: "website",
      icon_url: poster,
      title: "图图·海报",
      subtitle: "让作图提质增效。三步快速生成海报，不会PS也能设计",
      website_url: "http://ai.home.xinhua-news.com/poster/",
      // website_url: "http://ai.home.xhtxs.com/portal/aicheck_ui/",
      target: '_blank',
      isNew: true,
      // helpUrl: 'https://v.xinhua-news.com/nspfeatures/recommend/ocrhelp.mp4'
    },
  // {
  //   type: "website",
  //   icon_url: clouddisk,
  //   title: "新华社云盘",
  //   subtitle: "技术局研发的私有云服务",
  //   website_url: "http://yp.oa.xinhua-news.cn/yunpan/webservice/src/sso.php",
  //   target: '_blank'
  // },
  // {
  //   type: "website",
  //   icon_url: copyright,
  //   title: "新华全媒版权监测平台",
  //   subtitle: "技术局研发的版权监测平台",
  //   website_url: "http://cpright.xinhua-news.cn",
  //   target: '_blank'
  // }
  ],

  photosoftwares: [{
    type: "website",
    icon_url: p13,
    title: "美图秀秀",
    subtitle: "图片处理软件",
    website_url: 'http://xiuxiu.web.meitu.com/',
    // win_url: "http://home.cmp.xinhua-news.cn/download?fileName=XiuXiu"
  },
  // {
  //   type: "website",
  //   icon_url: p15,
  //   title: "暴走动画制作",
  //   subtitle: "图片处理软件",
  //   website_url: "http://baozoumanhua.com/makers/1",
  // },
  // {
  //   type: "download",
  //   icon_url: p16,
  //   title: "Photoshop",
  //   subtitle: "图片处理软件",
  //   win_url: "http://home.cmp.xinhua-news.cn/download?fileName=Photoshop"
  // },
  // {
  //   type: "download",
  //   icon_url: p17,
  //   title: "Lightroom",
  //   subtitle: "图片处理软件",
  //   win_url: "http://home.cmp.xinhua-news.cn/download?fileName=Lightroom"
  // },
  {
    type: "website",
    icon_url: p49,
    title: "图好快",
    subtitle: "在线图片压缩",
    website_url: "http://www.tuhaokuai.com/"
  }],

  gifsoftwares: [{
    type: "website",
    icon_url: p18,
    title: "GIF压缩",
    subtitle: "动图/视频",
    website_url: 'http://www.soogif.com/compress'
  },
  // {
  //   type: "website",
  //   icon_url: p19,
  //   title: "ImgPlay",
  //   subtitle: "动图/视频",
  //   website_url: 'http://imgplay.net/zhhans.html'
  // },
  {
    type: "website",
    icon_url: p20,
    title: "抠抠视频秀",
    subtitle: "动图/视频",
    website_url: 'http://www.28video.com/index.htm'
  },
  {
    type: "website",
    icon_url: p21,
    title: "Cinemagraph Pro",
    subtitle: "动图/视频",
    website_url: 'https://flixel.com/'
  },
  {
    type: "website",
    icon_url: p22,
    title: "Camtasia Studio",
    subtitle: "动图/视频",
    website_url: 'https://www.techsmith.com/video-editor.html'
  }],

  videosoftwares: [
  //   {
  //   type: "download",
  //   icon_url: p23,
  //   title: "秀拍客",
  //   subtitle: "视频制作",
  //   win_url: "http://home.cmp.xinhua-news.cn/download?fileName=XiuPaiKeSetup_pure",
  // },
  {
    type: "website",
    icon_url: p24,
    title: "VUE",
    subtitle: "视频制作",
    website_url: 'http://vuevideo.net/'
  },
  // {
  //   type: "website",
  //   icon_url: p25,
  //   title: "美摄",
  //   subtitle: "视频制作",
  //   website_url: 'http://mstj.cdv.com/index.html'
  // },
  {
    type: "website",
    icon_url: p26,
    title: "美拍",
    subtitle: "视频制作",
    website_url: 'http://www.meipai.com/'
  },
  // {
  //   type: "download",
  //   icon_url: p27,
  //   title: "爱剪辑",
  //   subtitle: "视频剪辑",
  //   win_url: 'http://home.cmp.xinhua-news.cn/download?fileName=MESetup'
  // },
  {
    type: "website",
    icon_url: p28,
    title: "快剪辑",
    subtitle: "视频剪辑",
    website_url: 'http://se.360.cn/welcome/wel_kjj_2.html'
  },
  {
    type: "website",
    icon_url: p29,
    title: "EDIUS",
    subtitle: "视频编辑",
    website_url: 'http://www.ediuschina.com/xiazai.html'
  },
  // {
  //   type: "download",
  //   icon_url: p30,
  //   title: "Adobe Premiere",
  //   subtitle: "视频编辑",
  //   win_url: "http://home.cmp.xinhua-news.cn/download?fileName=Premiere_Pro_Set-Up",
  // },
  // {
  //   type: "download",
  //   icon_url: p31,
  //   title: "Adobe After Effects",
  //   subtitle: "视频编辑",
  //   win_url: "http://home.cmp.xinhua-news.cn/download?fileName=After_Effects_Set-Up",
  // },
  {
    type: "website",
    icon_url: p32,
    title: "iMovie",
    subtitle: "视频编辑",
    website_url: 'https://www.apple.com/cn/imovie/'

  },
  {
    type: "website",
    icon_url: p33,
    title: "Final Cut Pro",
    subtitle: "视频编辑",
    website_url: 'https://www.apple.com/cn/final-cut-pro/'
  },
  // {
  //   type: "download",
  //   icon_url: p34,
  //   title: "Aegisub",
  //   subtitle: "字幕插件",
  //   win_url: "http://home.cmp.xinhua-news.cn/download?fileName=aegisub-3.2.2-portable-32",
  // }
],

  h5maker: [{
    type: "website",
    icon_url: p35,
    title: "秀米",
    subtitle: "H5图文排版",
    website_url: "https://xiumi.us/studio/v5#/paper/for/new",
  },
  {
    type: "website",
    icon_url: p36,
    title: "新媒体排版",
    subtitle: "H5图文排版",
    website_url: "https://xmt.cn/index",
  },
  // {
  //   type: "download",
  //   icon_url: p37,
  //   title: "木疙瘩",
  //   subtitle: "H5动画制作",
  //   win_url: "http://home.cmp.xinhua-news.cn/download?fileName=MugedaApp",
  // },
  {
    type: "website",
    icon_url: p38,
    title: "MAKA",
    subtitle: "H5动画制作",
    website_url: "http://maka.im/",
  },
  {
    type: "website",
    icon_url: p39,
    title: "意派360",
    subtitle: "H5图文排版",
    website_url: "http://www.epub360.com/",
  },
  {
    type: "website",
    icon_url: p40,
    title: "百度图说",
    subtitle: "数据图表制作",
    website_url: "http://tushuo.baidu.com/",
  }],

  sand: [{
    type: "website",
    icon_url: p41,
    title: "3Ds Max",
    subtitle: "三维动画制作",
    website_url: "https://www.autodesk.com.cn/products/3ds-max/overview",
  },
  {
    type: "website",
    icon_url: p42,
    title: "Autodesk Maya",
    subtitle: "三维动画制作",
    website_url: 'https://www.autodesk.com.cn/products/maya/overview'
  }],

  utils: [
  //   {
  //   type: "download",
  //   icon_url: p43,
  //   title: "超级录屏",
  //   subtitle: "录屏软件",
  //   win_url: "http://home.cmp.xinhua-news.cn/download?fileName=rd-screen-recorder",
  // },
  // {
  //   type: "download",
  //   icon_url: p44,
  //   title: "格式工厂",
  //   subtitle: "格式转换",
  //   win_url: "http://home.cmp.xinhua-news.cn/download?fileName=FormatFactory_setup",
  // },
  {
    type: "website",
    icon_url: p45,
    title: "Total Video Converter",
    subtitle: "格式转换",
    website_url: "http://www.effectmatrix.com/total-video-converter/index.htm",
  },
  // {
  //   type: "download",
  //   icon_url: p46,
  //   title: "硕思闪客精灵",
  //   subtitle: "SWF转FLA格式",
  //   win_url: "http://home.cmp.xinhua-news.cn/download?fileName=shankejingling_zhuanyeban",
  // },
  // {
  //   type: "download",
  //   icon_url: gold,
  //   title: "GoldWave",
  //   subtitle: "数字音频编辑软件",
  //   win_url: "http://home.cmp.xinhua-news.cn/download?fileName=goldwave",
  // },
  {
    type: "website",
    icon_url: p47,
    title: "讯飞语记",
    subtitle: "语音转文字的云笔记",
    website_url: 'http://www.iyuji.cn/iyuji/index'
  },
  {
    type: "website",
    icon_url: p48,
    title: "ScreenFlow",
    subtitle: "Mac 录屏软件",
    website_url: "https://screenflow.en.softonic.com/mac",
  }]

};

export default tools;